@use "Styles/includes/variables";
@use "Styles/mixins";

@keyframes confirm-modal-slide-in {
    from {
        opacity: 0;
        transform: translateY(-16px) scale(0.97);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes confirm-modal-slide-out {
    from {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
    to {
        opacity: 0;
        transform: translateY(-16px) scale(0.97);
    }
}

:host {
    display: contents;
}

.vm-confirm-modal {
    border: none;
    border-radius: 24px;
    padding: 0;
    max-width: 480px;
    width: calc(100% - 32px);
    background: mixins.get-color(bg, solid, primary);
    box-shadow:
        -2px -12px 48px -12px rgba(10, 13, 18, 0.18),
        4px -8px 4px -2px rgba(10, 13, 18, 0.04);
    animation: confirm-modal-slide-in 0.2s ease-out;
    outline: none;

    &::backdrop {
        @include mixins.overlay-backdrop;
    }

    &--closing {
        animation: confirm-modal-slide-out 0.2s ease-in forwards;

        &::backdrop {
            @include mixins.overlay-backdrop-closing;
        }
    }

    &__container {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 32px 24px;

        @include mixins.desktop-and-up {
            padding: 32px 54px;
        }
    }

    &__heading-wrap {
        display: flex;
        flex-direction: column;
        gap: 8px;

        &--with-icon {
            align-items: center;

            .vm-confirm-modal__heading {
                text-align: center;
            }
        }
    }

    &__icon {
        width: 24px;
        height: 24px;
        color: mixins.get-color(background, bg-error-solid-hover);
    }

    &__heading {
        margin: 0;
        font-family: variables.$fontQuaternary;
        font-size: 20px;
        line-height: 30px;
        font-weight: 900;
        color: mixins.get-color(text, text-primary);
    }

    &__buttons {
        display: flex;
        gap: 16px;

        vm-button {
            flex: 1 1 0;
            min-width: 0;
        }
    }
}
